import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { PreloaderProvider, usePreloader } from "./context/PreloaderContext";

// --- PUBLIC PAGES ---
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import DukamoMafiPage from "./pages/DukamoMafiPage";
import DukamoHawassaPage from "./pages/DukamoHawassaPage";
import DukamoBherawiPage from "./pages/DukamoBherawiPage";
import RoasteryPage from "./pages/RoasteryPage";
import ContactPage from "./pages/ContactPage";
import MenuPage from "./pages/MenuPage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage"; // NEW IMPORT
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import DeliveryOptionsPage from "./pages/DeliveryOptionsPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import CoffeeOfTheWeekPage from "./pages/CoffeeOfTheWeekPage";

// --- ADMIN PAGES ---
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminProductsPage from "./pages/AdminProductsPage";
import AdminMenuPage from "./pages/AdminMenuPage";
import AdminProductEditPage from "./pages/AdminProductEditPage";
import AdminMenuEditPage from "./pages/AdminMenuEditPage";
import AdminCategoriesPage from "./pages/AdminCategoriesPage";
import AdminTestimonialsPage from "./pages/AdminTestimonialsPage";
import NotFoundPage from "./pages/NotFoundPage";
import AdminPageEditor from "./pages/AdminPageEditor";
import HiderLoginPage from "./pages/HiderLoginPage";
import AdminOrdersPage from "./pages/AdminOrdersPage";

// Footer links
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import SalesPolicy from "./pages/SalesPolicy";
import Legal from "./pages/Legal";

import ScrollToTop from "./components/common/ScrollToTop";

function AppContent() {
  const { setIsPageReady } = usePreloader();
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPageReady(true);
    }, 100);
    return () => clearTimeout(timer);
  }, [location.pathname, setIsPageReady]);

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/locations/mafi" element={<DukamoMafiPage />} />
      <Route path="/locations/hawassa" element={<DukamoHawassaPage />} />
      <Route path="/locations/bherawi" element={<DukamoBherawiPage />} />
      <Route path="/roastery" element={<RoasteryPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/menu" element={<MenuPage />} />
      <Route path="/products" element={<ProductsPage />} />

      {/* NEW DYNAMIC PRODUCT DETAIL ROUTE */}
      <Route path="/products/:id" element={<ProductDetailPage />} />

      <Route path="/cart" element={<CartPage />} />
      <Route path="/delivery" element={<DeliveryOptionsPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/order-success" element={<OrderSuccessPage />} />
      <Route path="/coffee-of-the-week" element={<CoffeeOfTheWeekPage />} />
      <Route path="*" element={<NotFoundPage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/sales-policy" element={<SalesPolicy />} />
      <Route path="/terms" element={<TermsOfUse />} />
      <Route path="/legal" element={<Legal />} />
      <Route path="/admin-login" element={<AdminLoginPage />} />
      <Route path="/hider-login" element={<HiderLoginPage />} />
      <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
      <Route path="/admin/products" element={<AdminProductsPage />} />
      <Route path="/admin/products/new" element={<AdminProductEditPage />} />
      <Route
        path="/admin/products/edit/:productId"
        element={<AdminProductEditPage />}
      />
      <Route path="/admin/menu" element={<AdminMenuPage />} />
      <Route path="/admin/menu/new" element={<AdminMenuEditPage />} />
      <Route path="/admin/menu/edit/:itemId" element={<AdminMenuEditPage />} />
      <Route path="/admin/categories" element={<AdminCategoriesPage />} />
      <Route path="/admin/testimonials" element={<AdminTestimonialsPage />} />
      <Route path="/admin/orders" element={<AdminOrdersPage />} />
      <Route path="/admin/pages/:pageId" element={<AdminPageEditor />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const handleContextMenu = (e) => {
      if (e.target.tagName === "IMG") e.preventDefault();
    };
    const handleDragStart = (e) => {
      if (e.target.tagName === "IMG") e.preventDefault();
    };
    const handleKeyDown = (e) => {
      if (e.key === "F12") e.preventDefault();
      if (
        e.ctrlKey &&
        e.shiftKey &&
        (e.key.toLowerCase() === "i" || e.key.toLowerCase() === "j")
      )
        e.preventDefault();
      if (e.ctrlKey && e.key.toLowerCase() === "u") e.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("dragstart", handleDragStart);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("dragstart", handleDragStart);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <CartProvider>
      <Router>
        <PreloaderProvider>
          <ScrollToTop />
          <AppContent />
        </PreloaderProvider>
      </Router>
    </CartProvider>
  );
}

export default App;
